module.exports = "../../../../platform/assets/pageMainIcon/ig-basic-archives-8.svg";